"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const ContentHeader_1 = __importDefault(require("@Components/ContentHeader"));
const MatchHistoryStatusSection_1 = __importDefault(require("@Components/MatchComponents/MatchHistory/MatchHistoryStatusSection"));
const MatchHistorySearchHeader_1 = __importDefault(require("@Components/MatchComponents/MatchHistory/MatchHistorySearchHeader"));
const MatchHistorySearchContentHeader = () => (react_1.default.createElement("div", { className: "match-history-head" },
    react_1.default.createElement(ContentHeader_1.default, { title: 'Match History', descriptionElement: react_1.default.createElement(MatchHistorySearchHeader_1.default, null) },
        react_1.default.createElement(MatchHistoryStatusSection_1.default, null))));
exports.default = MatchHistorySearchContentHeader;
